import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-download-folder',
   templateUrl: 'download-folder.component.html',
   styleUrls: ['download-folder.component.css']
})
export class DownloadFolderComponent implements OnInit {
   private id: string;
   private timer: any;
   progress = 0;
   error: string;
   @ViewChild('cancel') cancel: MatButton;

   constructor(private dialogRef: MatDialogRef<DownloadFolderComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {}

   ngOnInit(): void {
      const that = this;
      this.data.service.post('/folder/download?id=' + this.data.id, {})
          .subscribe(data => {
             that.id = data.nodeRef;
             that.timer = setInterval(() => {
                that.checkStatus();
             }, 500);
          });
   }

   private checkStatus(): void {
      const that = this;
      const token = this.data.service.user.token;
      this.data.service.get('/download/status?id=' + this.id)
          .subscribe(data => {
             if (data.done === data.total && data.status === 'DONE' && data.filesAdded === data.totalFiles) {
                clearInterval(that.timer);
                that.progress = 100;
                that.cancel.disabled = true;
                location.href = that.data.service.downloadFileUrl(that.id, that.data.name + '.zip')
                   + '&token=' + token;
                setTimeout(() => {
                   that.cleanAndClose(this.cancel);
                }, 500);
             } else {
                that.progress = Math.floor(data.done * 100 / data.total);
             }
          }, error => {
             that.error = error;
             clearInterval(that.timer);
             that.delete();
          });
   }

   cleanAndClose(cancel: MatButton): void {
      cancel.disabled = true;
      if (this.id) {
         const that = this;
         this.delete().subscribe(() => { that.dialogRef.close(); }, () => { that.dialogRef.close(); });
      } else {
         this.dialogRef.close();
      }
   }

   private delete(): Observable<any> {
      return this.data.service.delete('/download?id=' + this.id);
   }
}
